module.exports = __webpack_public_path__ + "static/media/Face1_2.0a04ae09.png";